module.exports = __webpack_public_path__ + "static/media/map.3a634357.svg";